enum PlanoAtividadeStatusEnum {
    Rascunho = 1,
    AguardandoAprovacao = 2,
    Aprovado = 3,
    Reprovado = 4,
    Finalizado = 5,
    Inconsistente = 6,
    NovoTach = 7,
}

const PlanoAtividadeStatusEnumLabel = new Map<PlanoAtividadeStatusEnum, string>(
    [
        [PlanoAtividadeStatusEnum.Rascunho, "Rascunho"],
        [PlanoAtividadeStatusEnum.AguardandoAprovacao, "Aguardando Aprovação"],
        [PlanoAtividadeStatusEnum.Aprovado, "Aprovado"],
        [PlanoAtividadeStatusEnum.Reprovado, "Reprovado"],
        [PlanoAtividadeStatusEnum.Finalizado, "Finalizado"],
        [PlanoAtividadeStatusEnum.Inconsistente, "Inconsistente"],
        [PlanoAtividadeStatusEnum.NovoTach, "Necessário criar novo TACH"],
    ]
);

export { PlanoAtividadeStatusEnum, PlanoAtividadeStatusEnumLabel };
